import { render, staticRenderFns } from "./CeeYuuFooter.vue?vue&type=template&id=5019427f&scoped=true"
import script from "./CeeYuuFooter.vue?vue&type=script&lang=js"
export * from "./CeeYuuFooter.vue?vue&type=script&lang=js"
import style0 from "./CeeYuuFooter.vue?vue&type=style&index=0&id=5019427f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019427f",
  null
  
)

export default component.exports